<script lang="ts">
  import { session } from '$lib/state/session.svelte';
</script>

<div class="page-head">
  <div>
    <h1 class="h-title">Settings</h1>
    <div class="h-sub">Your account</div>
  </div>
</div>

<div class="card" style="max-width:420px;padding:6px 18px">
  <div class="meta-item">
    <div class="meta-lbl">Name</div>
    <div style="font-size:13.5px;color:var(--t1);font-weight:500">{session.me?.user.name || '—'}</div>
  </div>
  <div class="meta-item">
    <div class="meta-lbl">Email</div>
    <div style="font-size:13.5px;color:var(--t1);font-weight:500">{session.me?.user.email}</div>
  </div>
  <div class="meta-item">
    <div class="meta-lbl">Two-factor</div>
    <div style="font-size:13.5px;color:var(--t1);font-weight:500">
      {session.me?.user.totp_enabled ? 'Enrolled' : 'Not enrolled'}
    </div>
  </div>
</div>
